import React from 'react'
import { Icon } from 'routes/components/Shared'

export const PricingStartup = () => {
  return (
    <div className='pricing-startup'>
      <div className='flex-column pricing-startup__body'>
        <div className='page__background pricing-startup__background' />

        <h2 className='page__title pricing-startup__title'>
          <Icon className='pricing-startup__icon' type='pricing-startup' />
          Startup Discounts
        </h2>

        <p className='page__subtitle pricing-startup__subtitle'>
          Only starting out and can't afford our base pricing? We offer
          discounts to startups with &#60;$1M funding.
        </p>
      </div>
    </div>
  )
}
